<header class="flex justify-between mb-4">
  <h2>{{ 'CATEGORY_LIST.HEADER.CLIENT_CONSOLE_CONFIGURATION' | translate }}</h2>
  <app-button *appAgentWritable (btnClick)="openModal(1)" customClass="ml-2">
    {{ 'CATEGORY_LIST.HEADER.CREATE_CATEGORY' | translate }}
  </app-button>
</header>
@if (categories) {
  <div class="content-card p-6">
    @if (loading) {
      <div class="w-full flex justify-center m-2">
        <div role="status">
          <app-loading-spinner class="w-8 h-8"></app-loading-spinner>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    }
    @if (categories && categories.length > 0) {
      <div class="flex flex-wrap gap-2 border-b bg-surface-muted rounded-xl p-1">
        @for (category of categories; track $index) {
          <button [class]="category.id === currentCategory ? 'bg-surface-card': ''"
            class="flex flex-row items-center justify-between px-1 py-1 rounded-xl" (click)="SwitchToCategory(category)">
            <span [title]="category.name" class=" text-xs 2xl:text-sm">{{ category.name }}</span>
            <app-dropdown *appAgentWritable [(optionItems)]="optionItems" (click)="onDropdownClick(category.id)">
              <app-icon-more-actions class="size-4 mt-2"></app-icon-more-actions>
            </app-dropdown>
          </button>
        }
      </div>
      @if (errorMessage !== '') {
        <app-alert [type]="'error'" [message]="errorMessage" [dismissible]="true" (dismiss)="errorMessage = ''"></app-alert>
      }
      @if (!loading) {
        <app-instance-list [allInstances]="instances" [instances]="instances" [instanceNumber]="instanceNumber"
        [category]="category" [showInstance]="showInstance"></app-instance-list>
      }
    }
    @else {
      <app-empty-state
        title="CATEGORY_LIST.BODY.Empty_LIST"
        icon="folder"
        [actionLabel]="isAgent ? 'CATEGORY_LIST.HEADER.CREATE_CATEGORY' : undefined"
        (action)="openModal(1)"
      ></app-empty-state>
    }
  </div>
}

@if (modalValue() === 1) {
  <app-modal>
    <div class="text-lg text-center">{{ category ? ('MODAL.MODIFY_QUESTION' | translate) : ('MODAL.NEW_CATEGORY' |
    translate) }}</div>
    <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()" class="space-y-3">
      <app-input
        id="name"
        [label]="'MODAL.NAME' | translate"
        [ariaLabel]="'MODAL.NAME' | translate"
        formControlName="name"
        placeholder="Nom"
        [error]="categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched ? ('MODAL.REQUIRED_NAME' | translate) : null"
        [reserveErrorSpace]="false"
      ></app-input>

      <app-input
        id="code"
        [label]="'MODAL.CODE' | translate"
        [ariaLabel]="'MODAL.CODE' | translate"
        formControlName="code"
        placeholder="Code"
        [reserveErrorSpace]="false"
      ></app-input>

      <div class="flex flex-col">
        <label for="description" class="block text-sm font-medium text-stone-700 mb-1">{{ 'MODAL.DESCRIPTION' | translate }}</label>
        <textarea id="description" placeholder="Description" formControlName="description"
          class="w-full bg-surface-header/60 border-[1px] border-solid border-brand-border rounded-lg text-stone-800 placeholder:text-stone-400 outline-none hover:border-primary-200 focus:bg-white focus:border-primary-300 focus:shadow-focus transition-[background-color,border-color,box-shadow] p-2 text-sm"
          cols="30" rows="5"></textarea>
      </div>
      <div class="flex justify-end space-x-2">
        <app-button variant="outline" type="button" (btnClick)="closeModal()">
          {{ 'MODAL.CANCEL' | translate }}
        </app-button>
        <app-button type="submit" [loading]="isSaving" [disabled]="isSaving">
          {{ 'MODAL.SUBMIT' | translate }}
        </app-button>
      </div>
    </form>
  </app-modal>
  }@if (modalValue() === 2){
  <app-modal>
    <div class="flex flex-col items-center justify-center">
      <div class="flex items-center justify-center size-10 border rounded-full border-white bg-red-500"><i
      class="text-white fa-solid fa-xmark"></i></div>
      <span class="text-sm my-7">{{ 'MODAL.DELETE_CONFIRMATION' | translate }} {{category?.name}} ?</span>
      <div class="flex justify-end space-x-4">
        <app-button variant="outline" type="button" (btnClick)="closeModal()">
          {{ 'MODAL.CANCEL' | translate }}
        </app-button>
        <app-button (btnClick)="deleteCategory()">
          {{ 'MODAL.SUBMIT' | translate }}
        </app-button>
      </div>
    </div>
  </app-modal>
}